import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogActions,
  Typography,
  Box,
  Button,
  alpha,
} from '@mui/material';
import {
  LockClock as SessionExpiredIcon,
} from '@mui/icons-material';

interface SessionExpiredModalProps {
  open: boolean;
  onLogin: () => void;
}

export const SessionExpiredModal: React.FC<SessionExpiredModalProps> = ({ open, onLogin }) => {
  return (
    <Dialog
      open={open}
      maxWidth="xs"
      fullWidth
      disableEscapeKeyDown
      slotProps={{
        backdrop: {
          sx: {
            backdropFilter: 'blur(12px)',
            backgroundColor: 'rgba(0, 0, 0, 0.6)',
          }
        }
      }}
      PaperProps={{
        sx: {
          borderRadius: 2,
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
          overflow: 'hidden',
          zIndex: 1,
        }
      }}
    >
      {/* Header */}
      <Box
        sx={{
          background: (theme) => `linear-gradient(135deg, ${theme.palette.background.chipWarning} 0%, ${alpha(theme.palette.background.chipWarning, 0.85)} 100%)`,
          color: 'white',
          p: 3,
          textAlign: 'center',
        }}
      >
        <Box
          sx={{
            width: 72,
            height: 72,
            borderRadius: '50%',
            backgroundColor: 'rgba(255, 255, 255, 0.2)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 16px',
          }}
        >
          <SessionExpiredIcon sx={{ fontSize: 40 }} />
        </Box>
        <Typography variant="h5" sx={{ fontWeight: 600 }}>
          Sesión Expirada
        </Typography>
      </Box>

      <DialogContent sx={{ p: 3, textAlign: 'center' }}>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
          Tu sesión ha expirado por inactividad o el token de autenticación ya no es válido.
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Por favor, inicia sesión nuevamente para continuar usando la plataforma.
        </Typography>
      </DialogContent>

      <DialogActions sx={{ p: 2.5, pt: 0, justifyContent: 'center' }}>
        <Button
          onClick={onLogin}
          variant="contained"
          size="large"
          sx={{
            textTransform: 'none',
            px: 4,
            py: 1.5,
            fontWeight: 600,
            bgcolor: (theme) => theme.palette.background.buttonBg,
            color: (theme) => theme.palette.background.buttonText,
            '&:hover': {
              bgcolor: (theme) => theme.palette.background.buttonBg,
              filter: 'brightness(0.9)',
            }
          }}
        >
          Iniciar Sesión
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SessionExpiredModal;
